import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NavController } from '@ionic/angular';
import { FormServices } from 'src/app/services/form-services.service';
import { LoginService } from 'src/app/services/login.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';
import { TypeRegisterComponent } from '../type-register/type-register.component';
import { PushNotificationsService } from 'src/app/services/push-notifications.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  @Output() showLogin = new EventEmitter();
  @ViewChild('register') register;
  @Input() type: string = '';
  @Input() code: string = '';
  public registerForm: FormGroup;
  public domainId = environment.domainId;
  public fieldForms = undefined;
  public logo: string;
  public loaded = false;
  private _typeRegister = undefined;

  constructor(
    private loginService: LoginService,
    private formSv: FormServices,
    private paramSv: ParamServicesService,
    private uiSv: UiServices,
    private renderer: Renderer2,
    private navCtrl: NavController,
    private _pushSv: PushNotificationsService,
    private _translateSv: TranslateService
  ) {}

  async ngOnInit() {
    try {
      this.getLogo();
      if (this.type !== 'registerMayor') {
        await this.uiSv.showLoading();
        const existForm = this.paramSv.existDistributorSignUpRes;
        this.setRegisterForm(existForm);
        await this.uiSv.loading.dismiss();
      } else {
        this.paramSv.emitImagesObs.subscribe((item: any) => {
          this.getLogo();
          if (item.name === 'distributor') {
            const existForm = this.paramSv.existDistributorSignUpRes;
            this.setRegisterForm(existForm);
          }
        });
      }
    } catch (err) {
      await this.uiSv?.loading?.dismiss();
      console.error(err);
    }
  }

  getLogo() {
    const { logo } = this.paramSv.setLogo('Login');
    this.logo = logo;
  }

  onSubmit(token) {}

  async setRegisterForm(existForm) {
    try {
      if (existForm) {
        let dataType = undefined;
        if (this.type !== 'registerMayor') {
          const { data } = await this.uiSv.showModal(
            TypeRegisterComponent,
            {},
            'modalRegister'
          );
          dataType = data;
        } else {
          dataType = this.type;
        }
        if (dataType) {
          dataType === 'registro'
            ? (this._typeRegister = 'register')
            : (this._typeRegister = 'registerVerify');
          await this.uiSv.showLoading();
          let forms = await this.formSv.getForm(dataType, this.domainId);
          this.fieldForms = forms;
          await this.uiSv.loading.dismiss();
          this.loaded = true;
        } else {
          this.goLogin();
        }
      } else {
        this._typeRegister = 'register';
        await this.uiSv.showLoading();
        let forms = await this.formSv.getForm('registro', this.domainId);
        await this.uiSv.loading.dismiss();
        this.fieldForms = forms;
        this.loaded = true;
      }
    } catch (err) {
      console.error(err);
    }
  }

  async sendInfo(value: FormData) {
    try {
      value.append('parent', this.code);
      value.append('domainId', String(this.domainId));
      await this.loginService.signUp(
        value,
        this._typeRegister,
        null,
        this._pushSv.token
      );
      this.goLogin();
    } catch (err) {
      let message = err?.error?.error?.message;

      if (message === 'recaptcha_failed') {
        message = this._translateSv.instant('recaptcha_failed');
      }
      this.uiSv.presentAlert(message, false, 'Accept', false);
    }
  }

  goHome() {
    this.navCtrl.navigateBack('home');
  }

  goLogin() {
    this.register && this.renderer.addClass(this.register.el, 'fadeOut');
    setTimeout(() => {
      this.showLogin.emit('login');
    }, 500);
  }
}
